import { StyleSheet } from '@patternfly/react-styles';
export default StyleSheet.parse(`.pf-l-bullseye{--pf-l-bullseye--Padding:0;display:flex;align-items:center;justify-content:center;height:100%;padding:var(--pf-l-bullseye--Padding);margin:0;}`);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/@patternfly/patternfly-next/layouts/Bullseye/bullseye.css.js
// module id = 204
// module chunks = 0